import { createSlice } from "@reduxjs/toolkit";
import {
  getAllUsers,
  updateUser,
  deleteUser,
  blockUser,
  getUserByCode,
} from "./thunk";
import { toggleLike } from "../5-like/thunk";
import { toggleBookmark } from "../4-bookmark/thunk";

const initialState = {
  users: [],
  selectedUser: null,
  total: 0,
  pagination: {},
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // =========================
    // 🔵 GET ALL USERS
    // =========================
    builder
      .addCase(getAllUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data || [];
        state.pagination = action.payload.responseDetails?.pagination || {};
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.users = [];
      });

    // =========================
    // 🟡 UPDATE USER
    // =========================
    builder
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.users.findIndex(
          (user) => user._id === action.payload._id,
        );
        if (index !== -1) state.users[index] = action.payload;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to update user";
      });

    // =========================
    // 🔴 DELETE USER
    // =========================
    builder
      .addCase(deleteUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.loading = false;
        // console.log(action.payload);
        state.users = state.users.filter((user) => user.id !== action.payload);
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.loading = false;
        // console.log(action.payload);
        state.error = action.payload || "Failed to delete user";
      });

    // =========================
    // 🟠 BLOCK / UNBLOCK USER
    // =========================
    builder.addCase(blockUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder
      .addCase(blockUser.fulfilled, (state, action) => {
        state.loading = false;

        // const { id, isBlocked } = action.payload;
        // console.log(action.payload.id);
        const user = state.users.find((u) => u.id === action.payload.id);
        // console.log(user)
        if (user) {
          user.isBlocked = !user.isBlocked;
        }
      })

      .addCase(blockUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to change block status";
      });
    // =========================
    // 🟣 GET USER BY CODE
    // =========================
    builder
      .addCase(getUserByCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserByCode.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedUser = action.payload.data;
      })
      .addCase(getUserByCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(toggleLike.fulfilled, (state, action) => {
        const postId = action.meta.arg;
        const { liked } = action.payload;

        const post = state.selectedUser?.Posts.find((p) => p.id === postId);
        if (post) {
          post.liked = liked;
          post.likeCount += liked ? 1 : -1;
        }

        if (state.post && state.post.id === postId) {
          state.post.liked = liked;
          state.post.likeCount += liked ? 1 : -1;
        }
      })
      .addCase(toggleBookmark.fulfilled, (state, action) => {
        const postId = action.meta.arg;
        // const { bookmarked } = action.payload;
        // console.log(postId);
        // console.log(bookmarked);
        const post = state.selectedUser?.Posts.find((p) => p.id === postId);
        // console.log(post);
        if (post) {
          post.bookmarked = !post.bookmarked;
        }

        // if (state.post && state.post.id === postId) {
        //   state.post.bookmarked = !state.post.bookmarked;
        // }
      });
  },
});

export default userSlice.reducer;
